import { render, staticRenderFns } from "./SistemaControllerIndex.vue?vue&type=template&id=80242898"
import script from "./SistemaControllerIndex.vue?vue&type=script&lang=js"
export * from "./SistemaControllerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports